import React, { useEffect } from 'react';

const IssueCollector = () => {
  useEffect(() => {
    // Only load issue collector in development mode
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    try {
      const script = document.createElement('script');
      script.src = 'https://jcwilliams410.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-3o5b4z/b/5/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=2b59d4f5';
      script.async = true;
      script.onerror = () => {
        console.warn('Issue collector script failed to load (this is normal in production)');
      };
      document.body.appendChild(script);

      return () => {
        // Cleanup script if component unmounts
        const existingScript = document.querySelector(`script[src*="atlassian.net"]`);
        if (existingScript) {
          existingScript.remove();
        }
      };
    } catch (error) {
      console.warn('Failed to load issue collector:', error);
    }
  }, []);

  // Don't render anything in production
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return <div />;
};

export default IssueCollector;